import React from "react";
import reactStringReplace from "react-string-replace";
import { DA_BasicLink } from "../../../../atoms/BasicLink/BasicLink.component";
import { CMS_SITE_ORIGIN } from "../../../../../constants/urlRoot.constants";
import { DA_NavigationPageSimple } from "../../../../../interfaces/navigationPage.interface";
import S from "./SearchPage.module.scss";

export const _SearchPage = ({
    highlightedString,
    onResultClicked,
    ...props
}: DA_NavigationPageSimple & { highlightedString: string; onResultClicked: () => void }) => {
    // Check if using Hercules Animals Umbraco CMS
    const isHerculesAnimalsUmbraco =
        globalThis.cmsApiUrl === "https://hercules-animals.euwest01.umbraco.io/";

    // Get base URL - for Hercules Animals, extract only domain without path segments
    // because search results already contain full paths from root
    const getHref = () => {
        if (isHerculesAnimalsUmbraco) {
            const baseUrl =
                typeof window !== "undefined"
                    ? window.location.origin
                    : (globalThis.cmsFrontendUrl || "").match(/^(https?:\/\/[^/]+)/)?.[1] || "";
            return `${baseUrl}${props.url}`;
        }
        // For other CMS sites, use CMS_SITE_ORIGIN as before
        return `${CMS_SITE_ORIGIN}${props.url}`;
    };

    return (
        <DA_BasicLink onClick={onResultClicked} href={getHref()} target="_self" className={S.link}>
            <div className={S.data}>
                <div className={S.details}>
                    {reactStringReplace(
                        props.name,
                        new RegExp(`(${highlightedString})`, "ig"),
                        (match, index) => (
                            <b key={index}>{match}</b>
                        )
                    )}
                </div>
            </div>
        </DA_BasicLink>
    );
};
